import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface TipoInspeccionPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface TipoInspeccion {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface TipoInspeccionResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class TipoInspeccionService {
  private readonly apiUrl = `${environment.apiUrl}/api/tipo_inspeccion`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los tipos de inspección
   */
  getAll(): Observable<TipoInspeccion[]> {
    return this.http.get<TipoInspeccion[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  /**
   * Obtener tipo de inspección por ID
   */
  getById(id: number): Observable<TipoInspeccion> {
    return this.http.get<TipoInspeccion>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear tipo de inspección
   */
  create(
    payload: TipoInspeccionPayload
  ): Observable<TipoInspeccionResponse> {
    return this.http.post<TipoInspeccionResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar tipo de inspección
   */
  update(
    id: number,
    payload: Partial<TipoInspeccionPayload>
  ): Observable<TipoInspeccionResponse> {
    return this.http.put<TipoInspeccionResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar tipo de inspección
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar tipo de inspección
   */
  inactivar(id: number): Observable<TipoInspeccionResponse> {
    return this.http.put<TipoInspeccionResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar tipo de inspección
   */
  activar(id: number): Observable<TipoInspeccionResponse> {
    return this.http.put<TipoInspeccionResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}